/**
 * useQrSession Hook
 * Tracks ONLY: bounce (<5sec) and session_end
 */
import { useEffect, useRef } from 'react';
import { trackCustomerAction } from '../services/amplitude.service';

const BOUNCE_THRESHOLD_SECONDS = 5;

interface SessionState {
  startTime: number;
}

export function useQrSession(clubId: string, tableId: string | undefined): void {
  const sessionStateRef = useRef<SessionState>({
    startTime: Date.now(),
  });

  useEffect(() => {
    const sessionState = sessionStateRef.current;

    return () => {
      const sessionDurationSeconds = (Date.now() - sessionState.startTime) / 1000;

      try {
        if (sessionDurationSeconds < BOUNCE_THRESHOLD_SECONDS) {
          trackCustomerAction('customer_session_bounce', {
            clubId,
            tableId,
            session_duration_seconds: Math.round(sessionDurationSeconds),
            timestamp: new Date().toISOString(),
          });
          console.log('[QrSession] Bounce:', Math.round(sessionDurationSeconds), 'sec');
        } else {
          trackCustomerAction('customer_session_end', {
            clubId,
            tableId,
            session_duration_seconds: Math.round(sessionDurationSeconds),
            timestamp: new Date().toISOString(),
          });
          console.log('[QrSession] End:', Math.round(sessionDurationSeconds), 'sec');
        }
      } catch (error) {
        console.error('[QrSession]:', error);
      }
    };
  }, [clubId, tableId]);
}
